import httpRequest from '@/utils/request.js'

export const getCurrentGuide = () => httpRequest.httpGet({
  url: '/service/share/guide'
})

// 获取分组列表
export const getGroupList = () => httpRequest.httpGet({
  url: '/service/guide/groups'
})

// 根据分组Id获取对应列表
export const getGuideItemList = (groupId) => httpRequest.httpGet({
  url: `/service/guide/list/${groupId}`
})

// 编辑分组
export const updateGuideGroup = (guideGroup) => httpRequest.httpPut('/service/guide/group/update', guideGroup)
// 新增分组
export const addGuideGroup = (guideGroup) => httpRequest.httpPost('/service/guide/group/add', guideGroup)

// 删除分组
export const delGuideGroup = (id) => httpRequest.httpdelete(`/service/guide/group/del/${id}`)

// 编辑引导项
export const editGuideItem = (guide) => httpRequest.httpPut('/service/guide/update', guide)

// 删除引导项
export const delGuideItem = (id) => httpRequest.httpdelete(`/service/guide/del/${id}`)

// 新增引导项
export const addGuideItem = (guideItem) => httpRequest.httpPost('/service/guide/add', guideItem)

// 更新引导项状态
export const updateGuideStatus = (ids, status) => httpRequest.httpPost('/service/guide/update?ids=' + ids, { status })
